import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Box, Chip, makeStyles, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import WithIconHelper from "components/WithIconHelper";
import ChipInput from "material-ui-chip-input";
import { isValidIpAddress } from "utils/string";
import { Form } from "./types";

interface Props {
  value: string[];
  updateForm: Dispatch<SetStateAction<Form>>;
}

export default function AllowedIpMasks(props: Props) {
  const { t } = useTranslation("gateway");
  const { updateForm, value } = props;
  const classes = useStyles();

  const handleIpChanges = (chip: string, index?: number) => {
    if (!isValidIpAddress(chip)) return;

    updateForm(prev => {
      const update = { ...prev };
      const { allowedIpMasks } = update.gateway;

      if (typeof index !== "undefined") {
        update.gateway.allowedIpMasks = allowedIpMasks.filter((v: string) => {
          return v !== chip;
        });
      } else {
        update.gateway.allowedIpMasks = [...allowedIpMasks, chip];
      }

      return update;
    });
  };

  return (
    <Box className={classes.container}>
      <Typography variant="subtitle2" display="inline">
        {t("ipMaskLabel")}
      </Typography>
      <WithIconHelper
        position="after"
        text={t("common:chipInputHelper")}
        icon={<InfoOutlinedIcon fontSize="small" color="primary" />}
        buttonStyles={{ marginLeft: "10px" }}
      >
        <ChipInput
          fullWidth
          color="primary"
          variant="outlined"
          value={value}
          onAdd={handleIpChanges}
          onDelete={handleIpChanges}
          chipRenderer={CustomChip}
          InputProps={{
            multiline: true,
            style: {
              alignItems: "baseline",
              minHeight: "110px",
            },
          }}
        />
      </WithIconHelper>
    </Box>
  );
}

const CustomChip = ({ chip, className, handleClick, handleDelete }, key) => (
  <Chip
    className={className}
    key={key}
    label={chip}
    onClick={handleClick}
    onDelete={handleDelete}
    size="small"
    color="primary"
  />
);

const useStyles = makeStyles({
  container: {
    maxWidth: "75%",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});
